// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-footer {
  background: linear-gradient(120deg, #6b4092 0%, #5a377f 40%, #4b2f6b 100%);
  color: #ffffff;
  margin-top: 3rem;
  padding: 32px 0 26px;
  text-align: center;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  align-items: center;
}

.footer-brand {
  display: grid;
  gap: 10px;
  justify-items: center;
}

.footer-brand img {
  height: 54px;
}

.footer-brand p {
  margin: 0;
  max-width: 380px;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.footer-links a {
  color: #f1e7ff;
  font-weight: 700;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  transition: background 0.2s ease, color 0.2s ease;
}

.footer-links a:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
  text-decoration: none;
}

.footer-meta {
  display: grid;
  gap: 4px;
  color: #e7dbff;
  font-weight: 600;
}

.footer-meta p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/public-footer/public-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,0EAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,iDAAA;AACF;;AAEA;EACE,cAAA;EACA,qCAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;AACF","sourcesContent":[".public-footer {\n  background: linear-gradient(120deg, #6b4092 0%, #5a377f 40%, #4b2f6b 100%);\n  color: #ffffff;\n  margin-top: 3rem;\n  padding: 32px 0 26px;\n  text-align: center;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n  align-items: center;\n}\n\n.footer-brand {\n  display: grid;\n  gap: 10px;\n  justify-items: center;\n}\n\n.footer-brand img {\n  height: 54px;\n}\n\n.footer-brand p {\n  margin: 0;\n  max-width: 380px;\n}\n\n.footer-links {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.footer-links a {\n  color: #f1e7ff;\n  font-weight: 700;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.footer-links a:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.16);\n  text-decoration: none;\n}\n\n.footer-meta {\n  display: grid;\n  gap: 4px;\n  color: #e7dbff;\n  font-weight: 600;\n}\n\n.footer-meta p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
